import { GroupContext } from '../context';
import { InviteUserEvent } from './invite-user.event';

export async function inviteUser(evt: InviteUserEvent, ctx: GroupContext) {
  if (evt.name.length === 0) {
    return;
  }
  await ctx.state('groupMembers').insert({
    id: ctx.metadata.id,
    name: evt.name,
    email: evt.email,
    state: 'invited',
    auth: evt.user,
    createdAt: ctx.metadata.createdAt,
  });
  await ctx.emit('grant-access', {
    auth: evt.user,
    eventGrants: [
      { event: 'accept-invite', filters: [], access: 'write' },
    ],
  });
}
